<!--*
 * Component to show place item
 *
 * @author   mauricio.figueroa
 * @date     2020-07-03
 *
 * @copyright 2020 Smartmatic Corp. All Rights Reserved.
 *
 * @license
 *
 * Confidential information of Smartmatic Labs. Not for disclosure or
 * distribution prior written consent. This software contains code, techniques
 * and know-how which is confidential and proprietary to Smartmatic.
 *
 * Use of this software is subject to the terms of an end user license
 * agreement.
-->
<template>
  <div class="card p-5 shadow--sm h-100">
    <div class="container mb-5">
      <div class="row">
        <div class="col px-0">
          <b>{{ placeName }}</b>
        </div>
        <div class="col--5 text-right px-0" v-if="roomWorkflowPhaseName === 'Completed'">
          <status-label variation="info">
            {{ $t('siteDetail.placesList.rooms.OnVerification') }}
          </status-label>
        </div>
        <div class="col--5 text-right px-0" v-else-if="roomWorkflowPhaseName === 'Revision'">
          <status-label variation="alarm">
            {{ $t('siteDetail.placesList.rooms.returned') }}
          </status-label>
        </div>
        <div v-else-if="status === 'PENDING' || status === 'IN_PROGRESS'" class="col-auto">
          <status-label :variation="status === 'PENDING' ? 'none' : 'warning'">
            {{ stringStatus }}
          </status-label>
        </div>
        <div v-else-if="status === 'AVAILABLE'" class="col-auto">
          <status-label variation="info">
            {{ stringStatus }}
          </status-label>
        </div>
        <div v-else-if="isRoomComplete" class="col-auto">
          <status-label variation="success">
            {{ stringStatus }}
          </status-label>
        </div>
      </div>
      <div class="row" v-if="roomWorkflowPhaseName && roomWorkflowPhaseName !== 'Pending'">
        <div class="col px-0">
          <div>
            <b>{{ $t('siteDetail.placesList.rooms.comment') }}</b> {{ transitionComment }}
          </div>
        </div>
      </div>
    </div>
    <div class="mt-auto">
      <app-button
        v-if="status === 'PENDING' || status === 'IN_PROGRESS'"
        variation="primary"
        full-width
        :disabled="outOfTime"
        @click="onStartSurvey(false)">
        <div v-if="outOfTime">
          {{ $t('siteDetail.placesList.outOfTime') }}
        </div>
        <div v-else>
          {{ status === 'PENDING' ? $t('siteDetails.placesList.start') : $t('siteDetails.placesList.resume') }}
        </div>
      </app-button>
      <app-button
        v-else
        full-width
        btn-type="outline"
        @click="onStartSurvey(true)">
        {{ $t('siteDetails.placesList.see') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import store from '../../store/store';
import StatusLabel from '../StatusLabel.vue';
import AppButton from '@/components/AppButton';

export default {
  components: { StatusLabel, AppButton },
  'name': 'Place',
  'props': [
    'placeName',
    'status',
    'roomId',
    'assignmentId',
    'roomAssignmentId',
    'actionEnabled',
    'outOfTime',
    'roomWorkflowPhaseName',
    'transitionComment',
    'surveyViewMode'
  ],
  'computed': {
    stringStatus() {
      switch (this.status) {
        case 'PENDING':
          return this.$t('siteDetails.placesList.status.pending');
        case 'IN_PROGRESS':
          return this.$t('siteDetails.placesList.status.progress');
        case 'AVAILABLE':
          return this.$t('siteDetails.placesList.status.available');
        case 'COMPLETED':
          return this.$t('siteDetails.placesList.status.completed');
      }
    },
    isRoomComplete() {
      if (this.status === 'COMPLETED') {
        if (!this.roomWorkflowPhaseName) {
          return true;
        } else {
          return this.roomWorkflowPhaseName === 'Finished';
        }
      }
      return false;
    }
  },
  'methods': {
    'onStartSurvey': function (isCompleted) {
      if (!this.outOfTime) {
        if (isCompleted) {
          store.commit('setIsCompleteSurvey', { 'mode': true });
        } else {
          store.commit('setIsCompleteSurvey', { 'mode': false });
        }

        let loggedUser = JSON.parse(localStorage.getItem('vuex')).loggedUser

        let isSupervisor = false
        loggedUser.roles.forEach((rol) => {
          if (rol['role'] === 'SUPERVISOR') {
            isSupervisor = true
          }
        })

        store.commit("setSurveyViewMode", { mode: this.surveyViewMode });

        if(isSupervisor && this.status === 'IN_PROGRESS') {
          store.commit('setSurveyViewMode', {mode: false})
        }

        this.$router.push({
          'name': 'SurveyQuestionsScreen',
          'params': { 'roomId': this.roomId, 'assignmentId': this.assignmentId, 'roomAssignmentId': this.roomAssignmentId }
        })
      }
    }
  }
}
</script>
